"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isArray_1 = __importDefault(require("lodash/isArray"));
/**
 * @param deserializeElement
 * @param removeFailedItems Can be used in a testing environment where some items may be invalid
 */
function deserializeArray(deserializeElement, removeFailedItems = false) {
    return function (value) {
        if (!(0, isArray_1.default)(value)) {
            throw new Error(`Value "${JSON.stringify(value)}" is not an array`);
        }
        if (value.length === 0) {
            throw new Error('Value is an empty array (not allowed)');
        }
        return value
            .map((element, i) => {
            try {
                return deserializeElement(element, i);
            }
            catch (error) {
                if (removeFailedItems) {
                    console.log('Invalid item; ignoring', element);
                    return null;
                }
                else {
                    throw error;
                }
            }
        })
            .filter(element => element !== null);
    };
}
exports.default = deserializeArray;
